<template>
  <div class="body">
    <div style="width: 100%;overflow: hidden;height: 125px;">
      <ul style="width: 100%;">
        <li>
          <div class="ul_li">
            <div class="flex">
              <div style="float: left;width: 66px;">
                <i class="iconfont iconptdingdan1" style="font-size: 60px;color: #ff6700;"></i>
              </div>
              <div style="float: left;width: 200px;">
                <div style="width: 100%;text-align: center;color: #aaa;">
                  {{headTime*1 | formatDate}}已下单
                </div>
                <div style="width: 100%;text-align: center;font-size: 18px;margin-top: 10px;">
                  {{OrderNumber}}
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="ul_li">
            <div class="flex">
              <div style="float: left;width: 66px;">
                <i class="iconfont iconptqianfenleishouye" style="font-size: 60px;color: #32e235;"></i>
              </div>
              <div style="float: left;width: 200px;">
                <div style="width: 100%;text-align: center;color: #aaa;">
                  {{headTime*1 | formatDate}}已付款
                </div>
                <div style="width: 100%;text-align: center;font-size: 18px;margin-top: 10px;">
                  {{OrderPayNumber}}
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="ul_li">
            <div class="flex">
              <div style="float: left;width: 66px;">
                <i class="iconfont iconptqianfenleishouye" style="font-size: 60px;color: #ff3b0a;"></i>
              </div>
              <div style="float: left;width: 200px;">
                <div style="width: 100%;text-align: center;color: #aaa;">
                  {{headTime*1 | formatDate}}已退款
                </div>
                <div style="width: 100%;text-align: center;font-size: 18px;margin-top: 10px;">
                  {{OrderrefundpayNumber}}
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="ul_li">
            <div class="flex">
              <div style="float: left;width: 66px;">
                <i class="iconfont iconptyonghu" style="font-size: 60px;color: #1FA1F1;"></i>
              </div>
              <div style="float: left;width: 200px;">
                <div style="width: 100%;text-align: center;color: #aaa;">
                  {{headTime*1 | formatDate}}注册
                </div>
                <div style="width: 100%;text-align: center;font-size: 18px;margin-top: 10px;">
                  {{UserNumber}}
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!--折线图表-->
    <div style="width: 93%;height: 710px;overflow: hidden;margin: 0 auto;">
      <div style="width: 70%;height: 100%;overflow: hidden;float: left;">
        <div class="contentTOP_BOTTON">
          <div class="title">
            订单数量情况（笔）
            <span style="float: right;color: #000000;">
              日期选择
              <el-date-picker
                v-model="dataTime"
                type="month"
                placeholder="选择年月"
                size="mini"
                value-format="timestamp"
                @blur="getheadTime">
              </el-date-picker>
            </span>
          </div>
          <div>
            <hr color="#ddd">
          </div>
          <div class="photo" id="orders_num" v-loading="loading" element-loading-text="拼命加载中"></div>
        </div>
        <div class="contentTOP_BOTTON" style="margin-top: 20px;">
          <div class="title">
            账单金额情况（元）
          </div>
          <div>
            <hr color="#ddd">
          </div>
          <div class="photo" id="orders_money" v-loading="loading" element-loading-text="拼命加载中"></div>
        </div>
      </div>
      <div style="width: 29%;height: 100%;overflow: hidden;margin-left: 1%;float: left;">
        <div class="contentTOP_BOTTON">
          <div class="title">
            购买比例
          </div>
          <div>
            <hr color="#ddd">
          </div>
          <div class="photo" id="buy" v-loading="loading" element-loading-text="拼命加载中"></div>
        </div>
        <div class="contentTOP_BOTTON" style="margin-top: 20px;">
          <div class="title">
            配送方式比例
          </div>
          <div>
            <hr color="#ddd">
          </div>
          <div class="photo" id="peisong" v-loading="loading" element-loading-text="拼命加载中"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  var echarts = require('echarts');
export default {
  data () {
    return {
      //
      dataTime:'',
      //延迟
      loading:false,
      //订单数
      OrderNumber:0,
      //订单付款数
      OrderPayNumber:0,
      //订单退款数
      OrderrefundpayNumber:0,
      //用户数
      UserNumber:0,
      //时间抬头
      headTime:"",
      //管理员相关信息
      AdminInfor:{
        id:'',
        name:'',
        photo:'',
        type:'',
        time:'',
      },
    }
  },

  filters: {
        formatDate: function (value) {
          /*返回总体日期*/
          let date = new Date(value);
          let y = date.getFullYear();
          let MM = date.getMonth() + 1;
          MM = MM < 10 ? ('0' + MM) : MM;
          let d = date.getDate();
          d = d < 10 ? ('0' + d) : d;
          let h = date.getHours();
          h = h < 10 ? ('0' + h) : h;
          let m = date.getMinutes();
          m = m < 10 ? ('0' + m) : m;
          let s = date.getSeconds();
          s = s < 10 ? ('0' + s) : s;
          //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
          /*返回判断日期*/
          let timestamp = (new Date()).valueOf();
          let time=timestamp-value;//时间差
          let minute = 1000*60;
          let hour = minute * 60;
          var day = hour * 24;
          let times="";//内容
          let min = time/minute;//分钟
          let hours = time/hour;//天数
          return y + '年' + MM + '月';
        }
      },

  //页面开启时执行
  mounted(){
    this.judgeLogin()
    this.getheadTime();
    this.getlineImg();
  },
  //方法
  methods: {
    //进行订单的折线图
    getlineImg(){
      this.loading=true;
      let day=0;
      let year = this.formatDates(this.headTime).year;
      let month = this.formatDates(this.headTime).month;
      console.log(month)
      day=this.getNewMonthDay(year,month);
      let datas=[];
      for(let i=1;i<=day;i++){
        datas.push(i+"日");
      }
      this.getOrdersNumberDate(year,month,day,datas);
      this.getOrdersMoneyDate(year,month,day,datas);
      this.getPeisong(year,month,day,datas);
      this.getGoodsBuy(year,month,day,datas);
    },
    //获取商品购买数据
    getGoodsBuy(year,month,day,daydatas){
      commonAPI('queryOrders_buy', this.AdminInfor).then(res => {
        let data=res.data.data.rows
        let option = {
            title: {
                text: year+'年'+month+"月"+"订单商品购买情况",
                left: 'center'
            },
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c} ({d}%)'
            },
            series: [
                {
                    name: '购买情况',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: data,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        };
        let myChart = echarts.init(document.getElementById("buy"));
        myChart.setOption(option);
      })
    },
    //获取配送数据
    getPeisong(year,month,day,daydatas){
      commonAPI('queryOrders_peisong', this.AdminInfor).then(res => {
        let data=res.data.data.rows
        let option = {
            title: {
                text: year+'年'+month+"月"+"订单配送情况",
                left: 'center'
            },
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c} ({d}%)'
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                data: ['配送', '自取']
            },
            series: [
                {
                    name: '配送情况',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: data,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        };
        let myChart = echarts.init(document.getElementById("peisong"));
        myChart.setOption(option);
      })
    },
    //获取订单金额相关data数据
    getOrdersMoneyDate(year,month,day,daydatas){
      this.AdminInfor.types='0';
      commonAPI('queryOrders_money', this.AdminInfor).then(res => {
        let data1=this.zhexian_img_data(res.data.data.rows,year,month,day);
        //
        this.AdminInfor.types='1';
        commonAPI('queryOrders_money', this.AdminInfor).then(res => {
          let data2=this.zhexian_img_data(res.data.data.rows,year,month,day);
          //
          this.AdminInfor.types='7';
          commonAPI('queryOrders_refundpay', this.AdminInfor).then(res => {
            let data3=this.zhexian_img_data(res.data.data.rows,year,month,day);
            this.Orders_img_shuxie(year,month,daydatas,data1,data2,data3,'orders_money');
            this.loading=false;
          });
        });
      });
    },
    //获取订单数量相关data数据
    getOrdersNumberDate(year,month,day,daydatas){
      this.AdminInfor.types='0';
      commonAPI('queryOrders_nums', this.AdminInfor).then(res => {
        let data1=this.zhexian_img_data(res.data.data.rows,year,month,day);
        //
        this.AdminInfor.types='1';
        commonAPI('queryOrders_nums', this.AdminInfor).then(res => {
          let data2=this.zhexian_img_data(res.data.data.rows,year,month,day);
          //
          this.AdminInfor.types='7';
          commonAPI('queryOrders_nums', this.AdminInfor).then(res => {
            let data3=this.zhexian_img_data(res.data.data.rows,year,month,day);
            this.Orders_img_shuxie(year,month,daydatas,data1,data2,data3,'orders_num');
          });
        });
      });
    },
    //进行折线图内容数据编辑
    zhexian_img_data(data,year,month,day){
      let datas=[];
      let j=0;
      let days="";
      for(let i=1;i<=day;i++){
        if(i<=9){
          days="0"+i;
        }else{
          days=""+i;
        }
        if(data==''||data.length<=0){
          datas.push("0");
        }else{
          for(let j=0;j<data.length;j++){
            if(data[j].time==year+""+month+""+days){
              datas.push(data[j].data1);
              break;
            }else if(j==data.length-1){
              datas.push("0");
              break;
            }
          }
        }
      }
      return datas;
    },
    //进行订单数量折线图的书写
    Orders_img_shuxie(year,month,daydatas,datas1,datas2,datas3,name){
      let option = {
          title: {
            text: year+'年'+month+"月"+"订单情况"
          },
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          legend: {
            data: ['下单数', '付款数', '退款数']
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: daydatas
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            name: '下单数',
            data: datas1,
            type: 'line'
          },{
            name: '付款数',
            data: datas2,
            type: 'line'
          },{
            name: '退款数',
            data: datas3,
            type: 'line'
          }],
        };
      let myChart = echarts.init(document.getElementById(name));
      myChart.setOption(option);
    },
    //获取当月天数
    getNewMonthDay(year,month){
      if(month<10){
        month=month*1;
      }
      let day=0;
      switch (month) {
          case 1:
              day = 31;
              break;
          case 2:
              day = this.PDYearS(year);
               break;
          case 3:
              day = 31;
               break;
          case 4:
              day = 30;
               break;
          case 5:
              day = 31;
               break;
          case 6:
              day = 30;
               break;
          case 7:
              day = 31;
               break;
          case 8:
              day = 31;
               break;
          case 9:
              day = 30;
               break;
          case 10:
              day = 31;
               break;
          case 11:
              day = 30;
               break;
          case 12:
              day = 31;
      }
      return day;
    },
    //判定是闰年还是平年
    PDYearS(year){
      let day=0;
      if(year%400==0){
        day=29;
      }else if(year%4==0&&year%100!=0){
        day=29;
      }else{
        day=28;
      }
      return day;
    },
    //获取订单数
    getnewOrders_num(){
      this.AdminInfor.types='0';
      commonAPI('queryOrders_num', this.AdminInfor).then(res => {
        let data=res.data.data.rows[0].data1;
        this.OrderNumber=data;
        this.getnewPayOrders_num();
      });
    },
    //获取付款订单数
    getnewPayOrders_num(){
      this.AdminInfor.types='1';
      commonAPI('queryOrders_num', this.AdminInfor).then(res => {
        let data=res.data.data.rows[0].data1;
        this.OrderPayNumber=data
        this.getnewrefundPayOrders_num();
      });
    },
    //获取退款订单数
    getnewrefundPayOrders_num(){
      this.AdminInfor.types='7';
      commonAPI('queryOrders_num', this.AdminInfor).then(res => {
        let data=res.data.data.rows[0].data1;
        this.OrderrefundpayNumber=data
      });
    },
    //获取新增用户数
    getnewUserNumber(){
      commonAPI('queryReportUser', this.AdminInfor).then(res => {
        let data=res.data.data.rows[0].data1;
        this.UserNumber=data
      });
    },
    //进行当前日期获取
    getnewTime(){
      this.OrderNumber=0;
      //订单付款数
      this.OrderPayNumber=0;
      //订单退款数
      this.OrderrefundpayNumber=0;
      //用户数
      this.UserNumber=0;
      let year = this.formatDates(this.headTime).year;
      let month = this.formatDates(this.headTime).month;
      let time=year+""+month;
      this.AdminInfor.time=time;
      //console.log(time);
      this.getnewUserNumber();
      this.getnewOrders_num();
    },
    //时间抬头进行时
    getheadTime(){
      let time=new Date().getTime();
      if(this.dataTime!=''){
        time=this.dataTime;
      }
      this.headTime=time;
      this.getnewTime();
      this.getlineImg();
    },
    //获取信息方法
    judgeLogin(){
      this.AdminInfor.id=this.$store.state.a_id;
      this.AdminInfor.type=this.$store.state.a_type;
      /**
      if(this.AdminInfor.type*1>1){
        this.$message({
          message: '无此权限',
          type: 'error'
        });
        this.$router.go(-1);
      }
      */
    },
    //时间戳转换
    formatDates: function (value) {
      /*返回总体日期*/
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m;
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s;
      //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      /*返回判断日期*/
      let timestamp = (new Date()).valueOf();
      let time=timestamp-value;//时间差
      let minute = 1000*60;
      let hour = minute * 60;
      var day = hour * 24;
      let times="";//内容
      let min = time/minute;//分钟
      let hours = time/hour;//天数
      return {
        year:y,month:MM
      }
    }
  }
}
</script>

<style scoped>
  ul li{float: left;width: 23%;margin-left: 0.5%;margin-right: 0.5%;}
  .body{
    min-width: 1180px;
    height: 100%;
  }
  .boxs{
    border-radius: 10px;
    border: 1px solid #ddd;
  }
  .title{
    margin: 10px 10px;color: #1fa1f1;font-size: 16px;
  }
  .content{
    margin: 10px 10px;font-size: 16px;width: 100%;overflow: hidden;
  }
  .photo{
    width: 99%;height: 273px;margin: 0 auto;
  }
  .ul_li{
    min-width: 273px;
    width: 100%;
    border-radius: 7px;
    border: 1px solid #ddd;
    box-shadow:0px 2px 2px 2px #ddd;
    overflow: hidden;
  }
  .flex{
    margin: 10px 10px;
    width: 273px;
    height: 66px;
    /*flex 布局*/
    display: flex;
    /*实现垂直居中*/
    align-items: center;
    /*实现水平居中*/
    justify-content: center;
    text-align: justify;
  }
  .flexs{
    /*flex 布局*/
    display: flex;
    /*实现垂直居中*/
    align-items: center;
    /*实现水平居中*/
    justify-content: center;
    text-align: justify;
  }

  .contentTOP_BOTTON{
    border-radius: 10px;
    border: 1px solid #ddd;
    width: 99%;height: 338px;overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/admin/views/index/Report.vue